export type WebhookProvider = "foxglove";

export interface FoxgloveEventConfig {
  filter_instantaneous: boolean;
}

export interface FoxgloveUserConfig {
  foxglove_events: FoxgloveEventConfig | null;
}

export interface BeginWebhookIntegrationRequest {
  orgId: string;
  userConfig: FoxgloveUserConfig | null;
  webhookProvider: WebhookProvider;
  webhookEvents: string[];
}

export interface EnableWebhookIntegrationRequest {
  webhookEndpointId: string;
  webhookSecret: string;
  apiKey: string;
}

export enum WebhookIntegrationStatus {
  Pending = "pending",
  Active = "active",
  Failed = "failed",
  Disabled = "disabled",
}

export interface WebhookIntegrationRecord {
  webhook_endpoint_id: string;
  created: string;
  created_by: string;
  modified: string;
  modified_by: string;
  org_id: string;
  status: WebhookIntegrationStatus;
  user_config: Record<string, unknown> | null;
  webhook_endpoint_url: string;
  webhook_events: string[];
  webhook_provider: WebhookProvider;
  secret_registered: boolean;
  api_key_registered: boolean;
}
